import { apiClientWH } from '@shared/services/ApiClient';

export interface Shop {
  id: number;
  name: string;
  code?: string;
}

export interface ShopsResponse {
  data: Shop[];
  meta: {
    current_page: number;
    per_page: number;
    total: number;
  };
}

export class ShopsApiAdapter {
  constructor() {
    // No necesitamos crear un cliente HTTP separado, usamos apiClientWH directamente
  }

  async getShops(
    page: number = 1,
    perPage: number = 100
  ): Promise<ShopsResponse> {
    try {
      const response = await apiClientWH.get('/shops', {
        params: {
          page,
          per_page: perPage,
        },
      });

      return response.data;
    } catch (error: any) {
      console.log('🔍 ShopsApiAdapter - Error:', error);
      throw error;
    }
  }
}
